import * as http from '../../modules/http';

export const SALES_REQUEST_START = 'SALES_REQUEST_START';
export const SALES_REQUEST_SUCCESS = 'SALES_REQUEST_SUCCESS';
export const SALES_REQUEST_FAILED = 'SALES_REQUEST_FAILED';
export const SALES_REQUEST_NO_PERMISSION = 'SALES_REQUEST_NO_PERMISSION';

export function sales_request_start() {
    return {
        type: SALES_REQUEST_START
    };
}

export function sales_request_success(data) {
    return {
        type: SALES_REQUEST_SUCCESS,
        data: data
    };
}

export function sales_request_failed() {
    return {
        type: SALES_REQUEST_FAILED
    };
}

export function sales_request_no_permission() {
    return {
        type: SALES_REQUEST_NO_PERMISSION
    };
}

export function fetchSalesDataIfNeeded() {

    return (dispatch, getState) => {
        if (shouldFetchSalesData()) {
            return dispatch(fetchSalesData());
        }
    };
}

function shouldFetchSalesData(state,country,product,date,platform, accountID) {
    return true;

    if (!state.sales.data){
        return true;
    }
    else{
        return false;
    }
}


function fetchSalesData() {
    return ((dispatch) => {
        dispatch(sales_request_start());

        let request = 'providers';

        //http.getFromServer(request,
        return http.postToServer('providers/get',
            {},
            (response) =>  {dispatch(sales_request_success(response.data))},
            (response) =>  {dispatch(sales_request_failed())},
            (response) =>  {dispatch(sales_request_no_permission())}

        );

    });
}